export class DOMUtils {
    static getProperty(o, propertyName) {
        return o[propertyName]; // o[propertyName] is of type T[K]
    }
}
